import { createSlice } from '@reduxjs/toolkit';
import {
  createGiveaway,
  fetchGiveaways,
  fetchParticipiants,
  pickWinner,
  rerollWinner,
  updateGiveaway
} from './giveaway.actions';

const initialState = {
  giveaways: [],
  metaData: { total: 0, page: 1, perPage: 10 },

  participiants: [],
  participiantsMeta: { total: 0, page: 1, perPage: 10 },

  isLoadingGiveway: false,
  isLoadingParticipiants: false,
  isPickingWinner: false,
  isRerollingWinner: false
};

const giveawaySlice = createSlice({
  name: 'giveaway',
  initialState,
  reducers: {
    clearGiveawayState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(createGiveaway.pending, (state) => {
      state.isLoadingGiveway = true;
    });
    builder.addCase(createGiveaway.fulfilled, (state) => {
      state.isLoadingGiveway = false;
    });
    builder.addCase(createGiveaway.rejected, (state) => {
      state.isLoadingGiveway = false;
    });

    builder.addCase(fetchGiveaways.pending, (state) => {
      state.isLoadingGiveway = true;
    });
    builder.addCase(fetchGiveaways.fulfilled, (state, action) => {
      state.giveaways = action.payload.data;
      state.metaData = action.payload.metaData;
      state.isLoadingGiveway = false;
    });
    builder.addCase(fetchGiveaways.rejected, (state) => {
      state.isLoadingGiveway = false;
    });

    builder.addCase(fetchParticipiants.pending, (state) => {
      state.isLoadingParticipiants = true;
    });
    builder.addCase(fetchParticipiants.fulfilled, (state, action) => {
      state.participiants = action.payload.data;
      state.participiantsMeta = action.payload.metaData;
      state.isLoadingParticipiants = false;
    });
    builder.addCase(fetchParticipiants.rejected, (state) => {
      state.isLoadingParticipiants = false;
    });

    builder.addCase(pickWinner.pending, (state) => {
      state.isPickingWinner = true;
    });
    builder.addCase(pickWinner.fulfilled, (state) => {
      state.isPickingWinner = false;
    });
    builder.addCase(pickWinner.rejected, (state) => {
      state.isPickingWinner = false;
    });

    builder.addCase(rerollWinner.pending, (state) => {
      state.isRerollingWinner = true;
    });
    builder.addCase(rerollWinner.fulfilled, (state) => {
      state.isRerollingWinner = false;
    });
    builder.addCase(rerollWinner.rejected, (state) => {
      state.isRerollingWinner = false;
    });

    builder.addCase(updateGiveaway.pending, (state) => {
      state.isLoadingGiveway = true;
    });
    builder.addCase(updateGiveaway.fulfilled, (state) => {
      state.isLoadingGiveway = false;
    });
    builder.addCase(updateGiveaway.rejected, (state) => {
      state.isLoadingGiveway = false;
    });
  }
});

export const { clearGiveawayState } = giveawaySlice.actions;

export default giveawaySlice.reducer;
